import {
  QUICK_ORDER_CREATE_ITEM,
  QUICK_ORDER_DELETE_ITEM,
  QUICK_ORDER_DELETE_ITEMS,
  QUICK_ORDER_RECEIVE_ERROR,
  QUICK_ORDER_RECEIVE_ERROR_ITEM,
  QUICK_ORDER_RECEIVE_PARSE_ITEMS,
  QUICK_ORDER_UPDATE_ITEM,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

// Number of items you want to create
const numberOfItems = 4;

const generatedItems = Array.from({ length: numberOfItems }, () => ({
  id: Math.random(),
  articleNumber: '',
  quantity: 1,
}));

const defaultState = {
  errors: {},
  articles: [...generatedItems],
  totalPrice: {},
};

export const quickOrder = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case QUICK_ORDER_RECEIVE_PARSE_ITEMS:
      return {
        ...state,
        ...payload,
        errors: {},
      };
    case QUICK_ORDER_RECEIVE_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case QUICK_ORDER_CREATE_ITEM:
      return {
        ...state,
        articles: [...state.articles, payload.article],
        totalPrice: payload.totalPrice,
      };
    case QUICK_ORDER_DELETE_ITEM: {
      const { articleId } = payload;
      const items = state.articles.filter((item) => item.id !== articleId);
      return {
        ...state,
        articles: items,
      };
    }
    case QUICK_ORDER_DELETE_ITEMS: {
      return {
        ...state,
        articles: [],
      };
    }
    case QUICK_ORDER_UPDATE_ITEM:
    case QUICK_ORDER_RECEIVE_ERROR_ITEM: {
      const {
        article: { id, ...rest },
      } = payload;
      const items = state.articles.map((a) =>
        a.id === id ? { ...a, ...rest } : a
      );
      return {
        ...state,
        articles: items,
      };
    }
    default:
      return state;
  }
};
